module.exports = {
      id: "x-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#x-usage",
      toString: function () {
        return this.url;
      }
    }